<header class="header">
  <div class="header__container" [ngStyle]="{ 'max-width': maxWidth }">
    <app-brand [width]="170" [height]="30"></app-brand>
  </div>
</header>
